import React, { useEffect, useState } from "react";
import { href, Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdCalendarMonth,
  MdInventory,
  MdOutlineDashboard,
  MdPeople,
} from "react-icons/md";
import { FaAngleDown, FaSignOutAlt } from "react-icons/fa";
import logo from "../Asset/logo.jpg";

// import { logout } from "../apis/authApi";
// import { useAuth } from "../context/AuthProvider";
import { GiGoat } from "react-icons/gi";
import { GrDocumentDownload } from "react-icons/gr";
import { CiMoneyBill, CiSettings } from "react-icons/ci";
import { BsApp, BsViewList } from "react-icons/bs";
import { BiDollar } from "react-icons/bi";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { user, setUser, setLogin } = useAuth();

  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("activeButton") || "Dashboard"
  );
  const [openDropdown, setOpenDropdown] = useState(null);
const menuItems = [
  {
    name: "Dashboard",
    href: "/",
    icon: <MdOutlineDashboard />,
  },
  {
    name: "E-Stamp Enquiry",
    href: "/estamp-enquiry",
    icon: <GrDocumentDownload />,
  },
  {
    name: "Contact Enquiry",
    href: "/contact-enquiry",
    icon: <MdPeople />,
  },
];



  // const filteredMenuItems = user?.role === "admin" ? menuItems: menuItems.filter(item => user?.permissions[item.name]?.read);

  const filteredMenuItems = [
   
    ...menuItems
    
  ];
  // console.log(user?.permissions)
  
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    // logout().then(() => {
      // setLogin(false);
      // setUser(null);
      // localStorage.removeItem('token')
      navigate("/login");
    // });
  };

  const handleDropdownToggle = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = menuItems.find(
      (item) =>
        item.href === currentPath ||
        item.subItems?.some((sub) => sub.href === currentPath)
    );
    if (currentItem) {
      setActiveButton(currentItem.name);
      localStorage.setItem("activeButton", currentItem.name);
    }
  }, [location.pathname]);

  return (
    <>
      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 z-50 h-screen scrollbar-custom overflow-y-auto bg-white shadow-lg w-64 transition-transform duration-300 
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        {/* Logo */}
        <div className="p-4">
          <Link to="/" className="flex justify-center">
            <img src={logo} alt="Logo" className="w-28 h-auto" />
          </Link>
        </div>

        {/* Menu Items */}
        <ul className="px-4 space-y-2">
          {filteredMenuItems.map((item) => {
            const isActive = activeButton === item.name;
            return (
              <li key={item.name}>
                <div className="flex flex-col">
                  <button
                    className={`flex items-center justify-between p-2 rounded-md w-full text-left transition-colors 
                    ${
                      isActive
                        ? "bg-[#b7b7a1] text-white"
                        : "text-accent hover:bg-primary/20"
                    }`}
                    onClick={() => {
                      if (item.subItems) {
                        handleDropdownToggle(item.name);
                      } else {
                        setActiveButton(item.name);
                        localStorage.setItem("activeButton", item.name);
                        setIsSidebarOpen(false);
                        navigate(item.href);
                      }
                    }}
                  >
                    <div className="flex items-center space-x-3">
                      <span className="text-xl">{item.icon}</span>
                      <span className="font-medium">{item.name === "Setting" ? "Config": item.name}</span>
                    </div>
                    {item.subItems && (
                      <FaAngleDown
                        className={`transition-transform ${
                          openDropdown === item.name ? "rotate-180" : ""
                        }`}
                      />
                    )}
                  </button>

                  {item.subItems && openDropdown === item.name && (
                    <ul className="ml-10 mt-2 space-y-1">
                      {item.subItems.map((sub) => (
                        <li key={sub.name}>
                          <Link
                            to={sub.href}
                            className={`block px-2 py-1 rounded-md transition-colors ${
                              location.pathname === sub.href
                                ? "bg-primary text-white"
                                : "text-secondary hover:bg-secondary/20"
                            }`}
                            onClick={() => setIsSidebarOpen(false)}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            );
          })}

          {/* Logout Button */}
          <li className="mt-4">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-3 w-full p-2 rounded-md text-accent hover:bg-primary hover:text-white transition-colors"
            >
              <FaSignOutAlt className="text-xl" />
              <span className="font-medium">Logout</span>
            </button>
          </li>
        </ul>
      </div>

      {/* Overlay for Mobile */}
      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 z-10 bg-black bg-opacity-50 lg:hidden"
        ></div>
      )}
    </>
  );
};

export default Sidebar;
